import React from 'react'

import './style.css'

const ProgressMeter = ({ currentLength, maxLength }) => {

  const progress = Math.round((currentLength / maxLength) * 100)

  return (
    <div className="progress-meter">
      <span style={{ width: `${progress}%` }}/>
    </div>
  )
}

export default ProgressMeter
